export interface Resource {
  id: string;
  title: string;
  description: string;
  content: string;
  type: ResourceType;
  category: ResourceCategory;
  tags: string[];
  author_id: string;
  author_name?: string;
  is_published: boolean;
  is_featured: boolean;
  difficulty_level: DifficultyLevel;
  estimated_reading_time: number;
  external_url?: string;
  file_url?: string;
  thumbnail_url?: string;
  view_count: number;
  like_count: number;
  created_at: string;
  updated_at: string;
  published_at?: string;
}

export interface ResourceVisibility {
  id: string;
  resource_id: string;
  user_id: string;
  granted_by: string;
  granted_at: string;
  expires_at?: string;
  notes?: string;
}

export interface ResourceCategory {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  color: string;
  order_index: number;
  is_active: boolean;
  parent_id?: string;
  children?: ResourceCategory[];
}

export interface ResourceInteraction {
  id: string;
  resource_id: string;
  user_id: string;
  type: InteractionType;
  created_at: string;
}

export interface ResourceCollection {
  id: string;
  name: string;
  description: string;
  resources: Resource[];
  created_by: string;
  is_public: boolean;
  created_at: string;
}

// Enums
export enum ResourceType {
  ARTICLE = 'ARTICLE',
  VIDEO = 'VIDEO',
  DOCUMENT = 'DOCUMENT',
  LINK = 'LINK',
  TOOL = 'TOOL',
  TEMPLATE = 'TEMPLATE',
  GUIDE = 'GUIDE',
  CHECKLIST = 'CHECKLIST'
}

export enum ResourceCategory {
  BUSINESS_MODEL = 'BUSINESS_MODEL',
  LEGAL_STRUCTURE = 'LEGAL_STRUCTURE',
  FINANCING = 'FINANCING',
  MARKETING = 'MARKETING',
  MANAGEMENT = 'MANAGEMENT',
  IMPACT_MEASUREMENT = 'IMPACT_MEASUREMENT',
  NETWORKING = 'NETWORKING',
  DIGITAL_TOOLS = 'DIGITAL_TOOLS',
  SUSTAINABILITY = 'SUSTAINABILITY',
  INNOVATION = 'INNOVATION'
}

export enum DifficultyLevel {
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE',
  ADVANCED = 'ADVANCED',
  EXPERT = 'EXPERT'
}

export enum InteractionType {
  VIEW = 'VIEW',
  LIKE = 'LIKE',
  BOOKMARK = 'BOOKMARK',
  SHARE = 'SHARE',
  DOWNLOAD = 'DOWNLOAD'
}

// Form types
export interface CreateResourceForm {
  title: string;
  description: string;
  content: string;
  type: ResourceType;
  category: string;
  tags: string[];
  difficulty_level: DifficultyLevel;
  external_url?: string;
  is_featured: boolean;
}

export interface ResourceFilters {
  search?: string;
  category?: string;
  type?: ResourceType;
  difficulty?: DifficultyLevel;
  tags?: string[];
  featured?: boolean;
}

export interface VisibilityAssignment {
  resource_id: string;
  user_ids: string[];
  expires_at?: string;
  notes?: string;
}